// ** React Import
import React, { useEffect, useState, Suspense, lazy, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// ** Reactstrap
import { Row, Col, TabContent, TabPane, Button } from 'reactstrap';

// ** Components (Lazy)
const MyProfile = lazy(() => import('./MyProfile'));
const Achievements = lazy(() => import('./Achievements'));
const Files = lazy(() => import('./Files'));
const Courses = lazy(() => import('./Courses'));
const Orders = lazy(() => import('./Orders'));
const Contracts = lazy(() => import('./Contracts'));
const Tasks = lazy(() => import('./Tasks'));
const Goals = lazy(() => import('./Goals'));
const Events = lazy(() => import('../../../events/Events'));
const Support = lazy(() => import('./support'));
const Leaderboard = lazy(() => import('./Leaderboard'));
const GiftMain = lazy(() => import('./Gift'));

// ** Actions
import {
  getCommunityBadgesAction,
  getCommunityDetailsAction,
  getProfileAction,
  leaderboardSettingAction
} from '../../store/action';

import { useLocation, useHistory } from 'react-router-dom';
import { setProfileTab } from './store/reducer';

// ** Components
import ResponsiveNav from '../../component/nav';
import CompleteProfile from '../../component/completeprofile';
import LatestUpdate from '../../component/latestupdate';
import BreadCrumbs from '../../../../@core/components/breadcrumbs';
import MobileProfileNav from '../../component/MobileProfileNav';

import PunchId from './myProfile/PunchId';

import { FaFileContract, FaTasks, FaUserCircle } from 'react-icons/fa';
import { BiSolidZap } from 'react-icons/bi';
import { RiShoppingBag3Fill } from 'react-icons/ri';
import { PiChalkboardTeacherFill } from 'react-icons/pi';
import { GoGift, GoGoal } from 'react-icons/go';

// ** Icons
import { ArrowLeft } from 'react-feather';

// ** Styles
import '@styles/react/community/Profile.scss';
import '../../../../assets/styles/Profile.scss';
import Introduction from './introduction';
import { isMobile } from 'react-device-detect';

const locationInfo = JSON.parse(localStorage.getItem('location'));
const contactId = locationInfo?.contactId;

export const responsiveItems = [
  {
    str: 'Profile',
    num: null,
    path: 'profile',
    icon: <FaUserCircle size={20} />,
    isMobile: 'profile',
    tabNumber: 2,
    desktopPath: '/community/profile'
  },
  {
    str: 'My Contracts',
    num: null,
    path: 'Contracts',
    icon: <FaFileContract size={20} />,
    isMobile: 'contacts',
    tabNumber: 8,
    desktopPath: '/community/profile/contacts'
  },
  {
    str: 'My Events',
    num: null,
    path: 'Events',
    icon: <BiSolidZap size={20} />,
    isMobile: 'events',
    tabNumber: 10,
    desktopPath: '/community/profile/events'
  },
  {
    str: 'My Orders',
    num: null,
    path: 'Orders',
    icon: <RiShoppingBag3Fill size={20} />,
    isMobile: 'orders',
    tabNumber: 7,
    desktopPath: '/community/profile/orders'
  },
  {
    str: 'My Courses',
    num: null,
    path: 'Courses',
    icon: <PiChalkboardTeacherFill size={20} />,
    isMobile: 'courses',
    tabNumber: 6,
    desktopPath: '/community/profile/courses'
  },
  {
    str: 'My Tasks',
    num: null,
    path: 'Tasks',
    icon: <FaTasks size={20} />,
    isMobile: 'tasks',
    tabNumber: 9,
    desktopPath: '/community/profile/tasks'
  },
  {
    str: 'My Goals',
    num: null,
    path: 'Goals',
    icon: <GoGoal size={20} />,
    isMobile: 'goals',
    tabNumber: 4,
    desktopPath: '/community/profile/goals'
  },
  {
    str: 'Gift',
    num: null,
    path: 'Gift',
    icon: <GoGift size={20} />,
    isMobile: 'gift',
    tabNumber: 121,
    desktopPath: '/community/profile/gift'
  }
];

const Profile = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const store = useSelector((state) => state.socialCommunity);
  const leaderboardSetting = useSelector((state) => state.socialCommunity.leaderboardSetting);
  const profileTab = useSelector((state) => state.profile.profileTab);

  const [isMobileView, setIsMobileView] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedContractId, setSelectedContractId] = useState(null);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [isContract, setIsContract] = useState(false);
  const [selectedFamilyMemberId, setSelectedFamilyMemberId] = useState(contactId);

  const queryLocation = useLocation();

  //console.log(isProfileTab);

  const toggleProfileTab = (tab) => {
    console.log('tab>>>>>>>>>>>>', tab);
    if (profileTab !== tab) {
      // setProfileTab(tab);
      dispatch(setProfileTab(tab));
    }
  };

  const queryParams = new URLSearchParams(location.search);
  const activeQuery = queryParams.get('active');

  // Determine tab from query string on first mount
  useEffect(() => {
    const defaultTab = 2;
    const queryToTab = {
      events: 10,
      courses: 6,
      goals: 4,
      orders: 7,
      tasks: 9,
      contracts: 8,
      gift: 121,
      profile: 2
    };

    const savedTab = queryToTab[activeQuery] || defaultTab;
    dispatch(setProfileTab(savedTab));
    setSelectedRow(savedTab);
  }, [activeQuery]);

  // Fetch data
  useEffect(() => {
    if (contactId) {
      dispatch(getProfileAction(contactId));
      dispatch(
        getCommunityDetailsAction({
          userId: locationInfo?.assignerId,
          organizationId: locationInfo?.organizationId
        })
      );
      dispatch(leaderboardSettingAction({ communityId: store?.community?._id }));
      dispatch(getCommunityBadgesAction(store?.community?._id));
    }
  }, [contactId, store?.community?._id]);

  // Handle resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 767);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleBack = () => window.history.back();

  const handleSelectContract = () => setIsContract(true);
  const handleSelectOrder = () => setIsContract(true);

  const renderTabPane = (tabNum, Component, props = {}) =>
    profileTab === tabNum && (
      <TabPane tabId={tabNum}>
        <Component {...props} />
      </TabPane>
    );

  return (
    <Fragment>
      <div
        className="social email-application"
        style={{ display: 'inline', width: '100%', padding: '0px 20px 0px 0px' }}
      >
        {!isMobile && (
          <Row className="d-flex align-items-center justify-content-between">
            <Col md={11} className="pe-0">
              <BreadCrumbs
                breadCrumbTitle="Profile"
                breadCrumbParent="Profile"
                breadCrumbActive={'Details'}
              />
            </Col>
            <Col md={1}>
              <div style={{ marginLeft: !isMobile && '1.8rem' }}>
                <Button
                  color="primary"
                  size="sm"
                  outline
                  className="btn-round d-flex align-items-center"
                  onClick={(e) => handleBack()}
                >
                  <ArrowLeft size={18} />
                  <span className="ms-25">Back</span>
                </Button>
              </div>
            </Col>
          </Row>
        )}

        <Row className="g-1">
          <Col xxl={profileTab === 2 ? 8 : 12} xl={12} lg={12} md={12}>
            {isMobileView ? (
              !isContract && (
                <MobileProfileNav
                  profileTab={profileTab}
                  setProfileTab={(tab) => {
                    setSelectedRow(tab);
                    dispatch(setProfileTab(tab));
                  }}
                  setIsMobileView={setIsMobileView}
                  store={store}
                  selectedRow={selectedRow}
                  setSelectedRow={setSelectedRow}
                  selectedFamilyMemberId={selectedFamilyMemberId}
                  setSelectedFamilyMemberId={setSelectedFamilyMemberId}
                />
              )
            ) : (
              <Introduction
                communityId={store?.community?._id}
                profile={store.profile}
                responsiveItems={responsiveItems}
              />
            )}

            <TabContent
              activeTab={profileTab}
              style={isMobileView ? { height: 'calc(100dvh - 210px)', overflowY: 'auto' } : {}}
            >
              <Suspense fallback={<div>Loading...</div>}>
                {renderTabPane(2, MyProfile, { dispatch, store })}
                {renderTabPane(3, Achievements, { dispatch, store })}
                {renderTabPane(4, Goals, { store, dispatch })}
                {renderTabPane(6, Courses, { store, dispatch, selectedFamilyMemberId })}
                {renderTabPane(7, Orders, {
                  contactId,
                  selectedFamilyMemberId,
                  store,
                  dispatch,
                  isContract,
                  setIsContract,
                  selectedOrderId,
                  setSelectedOrderId,
                  handleSelectOrder
                })}
                {renderTabPane(8, Contracts, {
                  store,
                  dispatch,
                  selectedContractId,
                  setSelectedContractId,
                  isContract,
                  handleSelectContract,
                  setIsContract
                })}
                {renderTabPane(9, Tasks, { store, dispatch })}
                {renderTabPane(10, Events, { store, dispatch })}
                {renderTabPane(11, Leaderboard, { store, dispatch, leaderboardSetting })}
                {renderTabPane(12, Support, { store, dispatch })}
                {renderTabPane(121, GiftMain, { store, dispatch })}
              </Suspense>
            </TabContent>
          </Col>

          {!isMobileView && profileTab === 2 && (
            <>
              <Col xxl={4} xl={12} lg={12} md={12} className="px-0">
                <PunchId store={store} />
                <CompleteProfile store={store} />
                <LatestUpdate />
              </Col>
              <Col xxl={profileTab === '/community/profile' ? 8 : 12} xl={12} lg={12} md={12}>
                {isMobile ? (
                  <div>
                    {isContract === false && (
                      <MobileProfileNav
                        profileTab={profileTab}
                        setProfileTab={setProfileTab}
                        setIsMobileView={setIsMobileView}
                        store={store}
                        selectedRow={selectedRow}
                        setSelectedRow={setSelectedRow}
                        selectedFamilyMemberId={selectedFamilyMemberId}
                        setSelectedFamilyMemberId={setSelectedFamilyMemberId}
                      />
                    )}
                  </div>
                ) : (
                  <div></div>
                )}
                {!isMobile && (
                  <Introduction
                    communityId={store?.community?._id}
                    profile={store.profile}
                    responsiveItems={responsiveItems}
                  />
                )}
                {isMobile ? (
                  selectedRow !== null && (
                    <TabContent
                      activeTab={selectedRow}
                      style={{
                        height: 'calc(100dvh - 210px)',
                        overflowY: 'auto'
                      }}
                    >
                      <Suspense fallback={<div>Loading...</div>}>
                        {profileTab === 2 && (
                          <TabPane tabId={2}>
                            <MyProfile dispatch={dispatch} store={store} />
                          </TabPane>
                        )}
                        {profileTab === 3 && (
                          <TabPane tabId={3}>
                            <Achievements dispatch={dispatch} store={store} />
                          </TabPane>
                        )}
                        {profileTab === 4 && (
                          <TabPane tabId={4}>
                            <Goals store={store} dispatch={dispatch} />
                          </TabPane>
                        )}
                        {profileTab === 5 && (
                          <TabPane tabId={5}>
                            <Orders
                              contactId={contactId}
                              selectedFamilyMemberId={selectedFamilyMemberId}
                              store={store}
                              dispatch={dispatch}
                              isContract={isContract}
                              setIsContract={setIsContract}
                              selectedOrderId={selectedOrderId}
                              setSelectedOrderId={setSelectedOrderId}
                              handleSelectOrder={handleSelectOrder}
                            />
                          </TabPane>
                        )}
                        {profileTab === 6 && (
                          <TabPane tabId={6}>
                            <Courses
                              store={store}
                              dispatch={dispatch}
                              selectedFamilyMemberId={selectedFamilyMemberId}
                            />
                          </TabPane>
                        )}
                        {profileTab === 7 && (
                          <TabPane tabId={7}>
                            <Files store={store} dispatch={dispatch} isMobileView={isMobileView} />
                          </TabPane>
                        )}
                        {profileTab === 8 && (
                          <TabPane tabId={8}>
                            <Contracts
                              store={store}
                              dispatch={dispatch}
                              selectedContractId={selectedContractId}
                              setSelectedContractId={setSelectedContractId}
                              isContract={isContract}
                              handleSelectContract={handleSelectContract}
                              setIsContract={setIsContract}
                            />
                          </TabPane>
                        )}
                        {profileTab === 9 && (
                          <TabPane tabId={9}>
                            <Tasks store={store} dispatch={dispatch} />
                          </TabPane>
                        )}
                        {profileTab === 10 && (
                          <TabPane tabId={10}>
                            <Events store={store} dispatch={dispatch} />
                          </TabPane>
                        )}
                        {profileTab === 11 && (
                          <TabPane tabId={11}>
                            <Leaderboard
                              store={store}
                              dispatch={dispatch}
                              leaderboardSetting={leaderboardSetting}
                            />
                          </TabPane>
                        )}
                        {profileTab === 12 && (
                          <TabPane tabId={12}>
                            <Support store={store} dispatch={dispatch} />
                          </TabPane>
                        )}
                        {profileTab === 121 && (
                          <TabPane tabId={121}>
                            <GiftMain store={store} dispatch={dispatch} />
                          </TabPane>
                        )}
                      </Suspense>
                    </TabContent>
                  )
                ) : (
                  <TabContent activeTab={profileTab}>
                    {profileTab === 2 && (
                      <TabPane tabId={2}>
                        <MyProfile contactId={contactId} dispatch={dispatch} store={store} />
                      </TabPane>
                    )}
                    {/* {profileTab === 2 && (
                  <TabPane tabId={2}>
                    <Achievements dispatch={dispatch} store={store} />
                  </TabPane>
                )} */}
                    {profileTab === 4 && (
                      <TabPane tabId={4}>
                        <Goals store={store} dispatch={dispatch} />
                      </TabPane>
                    )}
                    {profileTab === 7 && (
                      <TabPane tabId={7}>
                        <Orders
                          contactId={contactId}
                          selectedFamilyMemberId={selectedFamilyMemberId}
                          store={store}
                          dispatch={dispatch}
                          isContract={isContract}
                          setIsContract={setIsContract}
                          selectedOrderId={selectedOrderId}
                          setSelectedOrderId={setSelectedOrderId}
                          handleSelectOrder={handleSelectOrder}
                        />
                      </TabPane>
                    )}
                    {profileTab === 6 && (
                      <TabPane tabId={6}>
                        <Courses
                          store={store}
                          dispatch={dispatch}
                          selectedFamilyMemberId={selectedFamilyMemberId}
                        />
                      </TabPane>
                    )}
                    {/* {profileTab === 6 && (
                  <TabPane tabId={6}>
                    <Files store={store} dispatch={dispatch} />
                  </TabPane>
                )} */}
                    {profileTab === 8 && (
                      <TabPane tabId={8}>
                        <Contracts
                          store={store}
                          dispatch={dispatch}
                          selectedContractId={selectedContractId}
                          setSelectedContractId={setSelectedContractId}
                          isContract={isContract}
                          handleSelectContract={handleSelectContract}
                        />
                      </TabPane>
                    )}
                    {profileTab === 9 && (
                      <TabPane tabId={9}>
                        <Tasks store={store} dispatch={dispatch} />
                      </TabPane>
                    )}
                    {profileTab === 10 && (
                      <TabPane tabId={10}>
                        <Events store={store} dispatch={dispatch} />
                      </TabPane>
                    )}
                    {profileTab === '/community/profile/leaderboard' && (
                      <TabPane tabId={10}>
                        <Leaderboard
                          store={store}
                          dispatch={dispatch}
                          leaderboardSetting={leaderboardSetting}
                        />
                      </TabPane>
                    )}
                    {profileTab === '/community/profile/support' && (
                      <TabPane tabId={11}>
                        <Support store={store} dispatch={dispatch} />
                      </TabPane>
                    )}
                    {profileTab === 121 && (
                      <TabPane tabId={121}>
                        <GiftMain store={store} dispatch={dispatch} />
                      </TabPane>
                    )}
                  </TabContent>
                )}
              </Col>
            </>
          )}
          {!isMobile && profileTab === '/community/profile' && (
            <Col xxl={4} xl={12} lg={12} md={12} className="px-0">
              <div>
                {/*<div className="d-flex justify-content-end">*/}
                {/*  <Button*/}
                {/*    size="sm"*/}
                {/*    style={{marginBottom:'1.6rem'}}*/}
                {/*    outline*/}
                {/*    color='danger'*/}
                {/*    className="btn-round d-flex align-items-center px-50"*/}
                {/*    onClick={() => dispatch(handleLogout(),history.push('/login'))}*/}
                {/*  >*/}
                {/*    <AiOutlinePoweroff  size={17} className=''/>*/}
                {/*    <span className="ms-25">LogOut</span>*/}
                {/*  </Button>*/}
                {/*</div>*/}
                <PunchId store={store} />
                <CompleteProfile store={store} />
                <LatestUpdate />
              </div>
            </Col>
          )}
        </Row>
      </div>
    </Fragment>
  );
};

export default Profile;
